<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>场馆系统</el-breadcrumb-item>
        <el-breadcrumb-item>游泳馆</el-breadcrumb-item>
        <el-breadcrumb-item>场馆管理</el-breadcrumb-item>
        <el-breadcrumb-item>票价信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="name" align="center" label="商品名称">
        </el-table-column>

        <el-table-column prop="price" align="center" label="商品价格(元)">
          <template slot-scope="scope">
            <span>{{ scope.row.price }}元</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        stadiumType: "",
        stadiumId: ""
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      }
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      });
      bodyParams.stadiumType = parseInt(this.$route.params.stadiumType);
      bodyParams.stadiumId = parseInt(this.$route.params.stadiumId);
      this.$http({
        url: global.apiUrl + "/stadium/ticket/list",
        method: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.dataList.length > 0) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
